/** ແປຂໍ້ຄວາມຜິດພາດ Workshop ເປັນພາສາລາວງ່າຍ — ຫຼີກຄຳອັງກິດໃນ UI */
export function formatWorkshopUserErrorMessage(raw: string): string {
  const s = raw.trim();
  if (!s) return "ເກີດຂໍ້ຜິດພາດ — ລອງອີກຄັ້ງ";

  const lower = s.toLowerCase();

  if (
    lower.includes("feature_disabled") ||
    lower.includes("feature not enabled") ||
    lower.includes("not enabled for this shop")
  ) {
    return "ໂມດູນນີ້ຖືກປິດໄວ້ສຳລັບຮ້ານນີ້";
  }
  if (lower.includes("inventory") && lower.includes("ປິດ")) {
    return s;
  }
  if (
    (lower.includes("inventory") && lower.includes("disabled")) ||
    lower.includes("inventory_disabled")
  ) {
    return "ຮ້ານປິດສາງ — ໃຊ້ແຕ່ຄ່າແຮງ ຫຼື ອາໄຫຼ່ຈາກ Marketplace/ລູກຄ້ານຳມາ";
  }
  if (
    lower.includes("permission") ||
    lower.includes("forbidden") ||
    lower.includes("ບໍ່ມີສິດ") ||
    lower.includes("missing merchant")
  ) {
    return "ບໍ່ມີສິດເຮັດລາຍການນີ້ — ຕິດຕໍ່ຜູ້ຄຸມຮ້ານ";
  }
  if (
    lower.includes("branch") &&
    (lower.includes("not allowed") || lower.includes("forbidden"))
  ) {
    return "ສາຂານີ້ບໍ່ອະນຸຍາດສຳລັບພະນັກງານ";
  }
  if (
    lower.includes("insufficient") ||
    lower.includes("stock") ||
    lower.includes("ສະຕ໋ອກ")
  ) {
    // ຖ້າເປັນລາວຢູ່ແລ້ວ ຄືນຄືນເດີມ
    if (/[\u0E80-\u0EFF]/.test(s)) return s;
    return "ສະຕ໋ອກບໍ່ພຽງພໍ";
  }
  if (lower.includes("verification")) {
    return "ຮ້ານຕ້ອງຢືນຢັນກ່ອນໃຊ້ຟີເຈີນີ້";
  }
  if (lower.includes("parts_locked")) {
    return "ກົດ «ລໍຖ້າອາໄຫຼ່» ແລ້ວ «ສ້ອມຕໍ່» ກ່ອນເພີ່ມອາໄຫຼ່";
  }
  if (lower.includes("unauthorized")) {
    return "ບໍ່ໄດ້ຮັບອະນຸຍາດ — ເຂົ້າສູ່ລະບົບໃໝ່";
  }

  return s;
}

export function workshopToastError(raw: unknown): string {
  if (raw instanceof Error) return formatWorkshopUserErrorMessage(raw.message);
  if (typeof raw === "string") return formatWorkshopUserErrorMessage(raw);
  return "ເກີດຂໍ້ຜິດພາດ — ລອງອີກຄັ້ງ";
}
